import clsx from "clsx";
import { Link, useLocation } from "react-router-dom";

import { useState } from "react";
import { renderRouteOptions, Routes } from "../../utils/routes";
import { NavigationMenu } from "./NavigationMenu";

interface NavbarProps {
    isOpenable?: boolean;
}

export const Navbar: React.FC<NavbarProps> = (props) => {
    const {
        isOpenable = true
    } = props;

    const location = useLocation();

    const [allowOpen, setAllowOpen] = useState(true);
    const [isOpen, setIsOpen] = useState(false);

    const handleOpenNavbar = () => {
        if (!isOpenable) return;

        setIsOpen(true);
    };

    const handleCloseNavbar = () => {
        setIsOpen(false);
        setAllowOpen(false);

        setTimeout(() => {
            setAllowOpen(true);
        }, 500);
    };

    return (
        <nav
            role="navigation"
            className={clsx(
                "group relative cursor-pointer bg-cs-900 text-white h-14 px-2 py-4 md:px-6 w-full flex justify-between items-center gap-8",
                "border-b-2 group-hover:border-b-cs-900",
                isOpenable ? "border-b-transparent dark:border-b-cs-500" : "border-b-transparent",
            )}
            onClick={handleOpenNavbar}
            onMouseLeave={handleCloseNavbar}
        >
            {/* <div className={clsx(
                "block lg:hidden"
            )}>
                <BurgerMenuButton />
            </div> */}

            <div
                className="cursor-pointer hidden md:flex items-center gap-4"
            >
                <Link
                    to={Routes.OVERVIEW}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <img
                        alt="Logo"
                        src="/favicon-dark-1.svg"
                        className="h-8 w-8 me-4"
                    />
                </Link>

                <h3 className="me-2">
                    {renderRouteOptions(location.pathname).title || "Llamanager"}
                </h3>
            </div>

            <div
                className={clsx(
                    "z-main-navbar absolute top-full translate-y-0.5 left-0 right-0 bg-cs-200 shadow",
                    // "opacity-0 invisible group-hover:visible group-hover:opacity-100",
                    (allowOpen && isOpen) ? "visible opacity-100" : "opacity-0 invisible",
                    "transition-all duration-300",
                )}
            >
                <NavigationMenu handleCloseNavbar={handleCloseNavbar} />
            </div>
        </nav>
    )
}